<template>
    <div class="main-content">
        <div class="breadcrumb">
            <Breadcrumb>
                <BreadcrumbItem>资产管理</BreadcrumbItem>
                <BreadcrumbItem>使用记录</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <div class="filter">
            <Form label-colon inline>
                <FormItem>
                    <Input v-model="keywords" placeholder="资产编码/资产名称/使用人" clearable/>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="doSearching">搜索</Button>
                </FormItem>
            </Form>
        </div>
        <div class="table">
            <div class="table-list">
                <Table stripe :columns="columns" :data="dataList" :loading="loading">
                    <template slot-scope="{ row, index }" slot="action">
                        <a v-if="permissionButton.view" @click="view(row, index)">查看</a>
                    </template>
                </Table>
                <viewRecord v-model="viewRecordShow" :assetId="assetId" v-on:getRecordPage="getRecordPage"></viewRecord>
            </div>
            <div class="table-footer">
                <Row>
                    <Col class="total" span="6">共 {{ total }} 条记录 第 {{ pageNum }}/{{ pages }} 页</Col>
                    <Col class="pagenation" span="18">
                        <Page :page-size="pageSize"
                              :total="total"
                              :current="pageNum"
                              :page-size-opts="[15,20,50,100]"
                              @on-change="changePage"
                              @on-page-size-change="changPageSize"
                              show-sizer
                              show-elevator/>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
import permission from '@/common/permission';
import { reqGetAthPage } from '../../../api/asset-api';
import viewRecord from '../record/view';

export default {
    name: 'recordList',
    components: {
        viewRecord,
    },
    data() {
        return {
            filter: {},
            columns: [
                {
                    title: '资产编码',
                    key: 'encoding',
                    tooltip: 'ture',
                    width: 200
                },
                {
                    title: '资产名称',
                    key: 'assetName',
                    tooltip: 'true',
                    minWidth: 200
                },
                {
                    title: '资产分类',
                    key: 'classifyName',
                    tooltip: 'ture',
                    width: 180
                },
                {
                    title: '品牌',
                    key: 'brand',
                    tooltip: 'true',
                    minWidth: 200
                },
                {
                    title: '型号',
                    key: 'model',
                    tooltip: 'true',
                    width: 150
                },
                {
                    title: 'SN码',
                    key: 'snCode',
                    tooltip: 'ture',
                    width: 150
                },
                {
                    title: '使用人',
                    key: 'userName',
                    tooltip: 'ture',
                    width: 100
                },
                {
                    title: '所属部门',
                    key: 'userDeptName',
                    tooltip: 'true',
                    width: 220
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 150
                }
            ],
            transferType: '',
            transferTypeArray: [],
            viewRecordShow: false,
            dataList: [],
            assetId: '',
            loading: false,
            keywords: '',
            permissionButton: {
                add: false,
                edit: false,
                del: false,
                view: false,
            },
            total: 0,
            pages: 1,
            pageNum: 1,
            pageSize: 20
        }
    },
    methods: {
        //分页点击，切换页面
        changePage(val) {
            this.pageNum = val;
            this.getRecordPage();
        },
        //每页显示的数据条数
        changPageSize(numOfRows) {
            //实时获取当前需要显示的条数
            this.pageSize = numOfRows;
            this.getRecordPage();
        },
        view(row, index){
            this.assetId = row.assetId;
            this.viewRecordShow = true;
        },
        //获取分页列表
        getRecordPage() {
            let that = this;
            that.loading = true;
            that.dataList = [];
            let para = {
                pageNum: that.pageNum,
                pageSize: that.pageSize,
                keywords: that.keywords,
            };
            reqGetAthPage(para).then((res) => {
                that.loading = false;
                that.total = res.data.data.total;
                that.pages = res.data.data.pages;
                that.dataList = res.data.data.records;
            }).catch(() => {
                that.loading = false;
                that.dataList = [];
            });
        },
        doSearching(){
            this.pageNum = 1;
            this.getRecordPage();
        }
    },
    mounted() {
        this.getRecordPage();
        let permissionId = this.$route.query.permissionId;
        permission.getPermissionButton(permissionId, this.permissionButton);
    }
}
</script>
